"use strict";

exports.__esModule = true;
exports.MODERN_OVERLAY = void 0;
exports.modernTheme = modernTheme;
var _base = _interopRequireDefault(require("../../../Themes/base"));
var _resolveThemeVars = require("../resolveThemeVars");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
// Every token the modern UI changes or adds, as raw values. Tokens the legacy
// theme derives from these with `$ref` (ScreenBackground, TextColor, …) are
// re-resolved below so they follow.
var MODERN_TOKENS = {
  "bp6-intent-primary": "#E8621E",
  "bp6-intent-primary-disabled": "#E8621E80",
  "bp6-app-background-color": "#EFF2F4",
  color: "#1B2227",
  mutedColor: "#7C8A94",
  linkColor: "#1565A8",
  selectedColor: "#1B2227",
  selectedBorderColor: "#3A86C8",
  selectedBackground: "#EEF4FB",
  borderColor: "#E3E7EA",
  toolbarBorderColor: "#E3E7EA",
  tabIndicatorColor: "#3A86C8",
  NavbarHeight: "56px",
  NavbarColor: "#E7ECEF",
  NavbarBackground: "#242A30",
  NavbarBackgroundColor: "#242A30",
  NavbarTitleFontSize: "17px",
  NavbarTitleFontWeight: "600",
  NavbarSubTitleColor: "#9FADB6",
  SidebarWidth: "76px",
  SidebarLinkColor: "#D5DDE2",
  SidebarLinkFontWeight: "600",
  SidebarBackground: "#242A30",
  SidebarHoverBackground: "#242A30",
  SidebarActiveColor: "#ffffff",
  SidebarIconHoverBackground: "rgba(255, 255, 255, 0.07)",
  SidebarIconActiveBackground: "#E8621E",
  ToolbarBackground: "#ffffff",
  ToolbarHoverBackground: "#F1F4F6",
  PanelBorder: "solid 1px #E3E7EA",
  PanelHeaderBorder: "solid 1px #E3E7EA",
  LogbookHeaderHeight: "56px",
  BrushHandleEdgeBackground: "#2F6FA8",
  BrushHandleBackground: "#3A86C8",
  BrushHandleColor: "#ffffff",
  BrushBorder: "#3A86C8",
  BrushColor: "#1B2227",
  BrushBackgroundColor: "#ffffff",
  SelectionModeBackgroundColor: "#EFF2F4",
  SelectionModeColor: "#3D4A53",
  ChartTitleColor: "#1B2227",
  ChartStrokeColor: "#3A86C8",
  ToolTipHandleColor: "#3A86C8",
  TooltipTextBackground: "#F1F4F6",
  TooltipContentBorderBottomColor: "#E3E7EA",
  TooltipContentColor: "#1B2227",
  TooltipContentBackgroundColor: "#ffffff",
  TimeLineInstanceColor: "#6E7B85",
  TimeLineProcessColor: "#6E7B85",
  TimeLineKindColor: "#6E7B85",
  TimeLineShiftColor: "#3A86C8",
  DefaultChartColor: "#3A86C8",
  TooltipCursorFillColor: "#EFF2F4",
  ChartBrushColor: "#3A86C8",
  // Chart surface language, shared by the stripe chart, axes, legends and
  // tooltips. Values come from the next-gen reference design.
  ChartTrackColor: "#EFF2F4",
  ChartGridColor: "#EFF2F4",
  ChartAxisTextColor: "#8B98A1",
  ChartLegendTextColor: "#5A6771",
  ChartDividerColor: "rgba(255, 255, 255, 0.7)",
  ChartBarRadius: "5px",
  ChartFontFamilyMono: '"IBM Plex Mono", ui-monospace, Menlo, Consolas, "DejaVu Sans Mono", monospace',
  FontFamilySans: '"IBM Plex Sans", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
  FontFamilyHeading: 'Archivo, "IBM Plex Sans", -apple-system, BlinkMacSystemFont, sans-serif',
  ChartCardBackground: "#ffffff",
  ChartCardBorderColor: "#E3E7EA",
  ChartCardRadius: "11px",
  // Cards float on the canvas as soft shadow boxes rather than hairline frames.
  CardShadow: "0 1px 2px rgba(29, 36, 41, 0.06), 0 6px 16px rgba(29, 36, 41, 0.08), 0 20px 40px -16px rgba(29, 36, 41, 0.14)",
  CardShadowRaised: "0 2px 4px rgba(29, 36, 41, 0.08), 0 10px 24px rgba(29, 36, 41, 0.10), 0 28px 56px -20px rgba(29, 36, 41, 0.18)",
  ButtonShadow: "0 1px 2px rgba(29, 36, 41, 0.08), 0 3px 10px -2px rgba(29, 36, 41, 0.12)",
  ButtonShadowHover: "0 2px 4px rgba(29, 36, 41, 0.10), 0 8px 18px -4px rgba(29, 36, 41, 0.18)",
  ChartCardTitleColor: "#1B2227",
  ChartCardSubtitleColor: "#8B959A",
  ChartCardChipBackground: "#F1F4F6",
  ChartCardChipColor: "#5A6771",
  KpiLabelColor: "#7C8A94",
  KpiValueColor: "#1B2227",
  // Plant states, one step deeper than the legacy pastels so a card edge or a
  // stripe reads from across the floor. Same hues, an even lightness across
  // the family, and dark text still passes on every one of them.
  ProducingStateColor: "#3D9E55",
  StandbyStateColor: "#8FBC8F",
  SetupStateColor: "#B686B6",
  UnplannedDowntimeStateColor: "#D5514B",
  PlannedDowntimeStateColor: "#F0A94B",
  DataUnavailableStateColor: "#A6AEB4",
  ShutdownStateColor: "#4189C8",
  ChartTooltipBorderColor: "#E3E7EA",
  ChartTooltipShadow: "0 1px 2px rgba(29, 36, 41, 0.06), 0 12px 28px rgba(29, 36, 41, 0.16)"
};
var legacyResolved = (0, _resolveThemeVars.resolveThemeVars)(_base["default"], _base["default"]);
var modernMerged = Object.assign({}, _base["default"], MODERN_TOKENS);
var modernResolved = (0, _resolveThemeVars.resolveThemeVars)(modernMerged, modernMerged);

/**
 * The resolved tokens that differ between the legacy base theme and the
 * modern one, plus the `uiModern` marker styled components can branch on.
 */
var MODERN_OVERLAY = exports.MODERN_OVERLAY = Object.keys(modernResolved).reduce(function (overlay, key) {
  if (modernResolved[key] !== legacyResolved[key]) {
    overlay[key] = modernResolved[key];
  }
  return overlay;
}, {
  uiModern: true
});

/**
 * The modern theme for a subtree: the tenant's resolved theme with the
 * overlay on top.
 */
function modernTheme(outerTheme) {
  return Object.assign({}, outerTheme || legacyResolved, MODERN_OVERLAY);
}